













import Vue from 'vue';
export default Vue.extend({
	name: 'IconList', 
	props: ['items'], 
	methods: {
		getColourStyles(i: any): string {
			const bg = `background-color: ${i.colour}; `;
			const bo = i.bordercolour ? `border: solid 1px ${i.bordercolour} ` : '';
			return bg + bo;
		}
	}
});
